import type { Drug } from "../types";

export const hydrogenPeroxideDrug: Drug = {
  id: "hydrogen_peroxide_cream",
  name: "Hydrogen peroxide 1% cream",
  drugClass: "antiseptic",
  defaultFoodTiming: "For topical use only",
  formulations: [
    {
      id: "h2o2-1pct-25g",
      type: "topical_cream",
      strength: 1,
      strengthUnit: "%",
      tubeSize: 25,
      tubeSizeUnit: "g",
    },
    {
      id: "h2o2-1pct-40g",
      type: "topical_cream",
      strength: 1,
      strengthUnit: "%",
      tubeSize: 40,
      tubeSizeUnit: "g",
    },
  ],
};
